import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class QueryDashService {
  constructor(private http: HttpClient) {}

  segmentCount(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }

    return this.http.get<any>(
      `${environment.apiUrl}/helpdesk/dash/segmentCount`,
      { params: param }
    );
  }
  regionCount(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any>(
      `${environment.apiUrl}/helpdesk/dash/regionCount`,
      { params: param }
    );
  }

  sosRegionCount$ = this.http.get<any>(
    `${environment.apiUrl}/helpdesk/dash/sosRegionCount`
  );
  sosSegmentCount$ = this.http.get<any>(
    `${environment.apiUrl}/helpdesk/dash/sosSegmentCount`
  );
  ivrCallRegionCount$ = this.http.get<any>(
    `${environment.apiUrl}/helpdesk/dash/ivrCallRegionCount`
  );
  ivrCallSegmentCount$ = this.http.get<any>(
    `${environment.apiUrl}/helpdesk/dash/ivrCallSegmentCount`
  );

  segmentAdoptionCount$ = this.http.get<any>(
    `${environment.apiUrl}/helpdesk/dash/segmentAdoptionCount`
  );
  regionAdoptionCount$ = this.http.get<any>(
    `${environment.apiUrl}/helpdesk/dash/regionAdoptionCount`
  );

  categoryCount(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any>(
      `${environment.apiUrl}/helpdesk/dash/categoryCount`,
      { params: param }
    );
  }

  subCategoryCount(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any>(
      `${environment.apiUrl}/helpdesk/dash/subCategoryCount`,
      { params: param }
    );
  }

  complianceQueryCount(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any>(
      `${environment.apiUrl}/helpdesk/dash/complianceQueryCount`,
      { params: param }
    );
  }

  complianceRegionCount(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any>(
      `${environment.apiUrl}/helpdesk/dash/complianceRegionCount`,
      { params: param }
    );
  }

  complianceSegmentCount(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any>(
      `${environment.apiUrl}/helpdesk/dash/complianceSegmentCount`,
      { params: param }
    );
  }

  statusCount(data: any): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any>(
      `${environment.apiUrl}/helpdesk/dash/statusCount`,
      { params: param }
    );
  }

  wpdStatusCount(data: any): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any>(
      `${environment.apiUrl}/helpdesk/dash/wpdStatusCount`,
      { params: param }
    );
  }

  wpdRegionCount(data: any): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any>(
      `${environment.apiUrl}/helpdesk/dash/wpdRegionCount`,
      { params: param }
    );
  }

  wpdSegmentCount$ = this.http.get<any>(
    `${environment.apiUrl}/helpdesk/dash/wpdSegmentCount`
  );

  wpdJobRoleCount(data: any): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any>(
      `${environment.apiUrl}/helpdesk/dash/wpdJobRoleCount`,
      { params: param }
    );
  }

  wpdFiscalYear$ = this.http.get<any>(
    `${environment.apiUrl}/helpdesk/wpd_fiscal_year`
  );

  centeralQueryCount(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any>(
      `${environment.apiUrl}/helpdesk/dash/centeralQueryCount`,
      { params: param }
    );
  }

  centeralRegionCount(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any>(
      `${environment.apiUrl}/helpdesk/dash/centeralRegionCount`,
      { params: param }
    );
  }

  centeralSegmentCount(data): Observable<any> {
    let param = new HttpParams();
    for (const key in data) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        param = param.append(key, data[key]);
      }
    }
    return this.http.get<any>(
      `${environment.apiUrl}/helpdesk/dash/centeralSegmentCount`,
      { params: param }
    );
  }
}
